export default "__VITE_ASSET__CBQw6Xp2__"